import { useTranslation } from "react-i18next";
import Illustration from "../../assets/images/illustration-4.png";
import { Heading, Image } from "../elements";

const BannerSection = () => {
    const { t } = useTranslation();

    return (
        <div className="banner-section">
            <Heading level="h1">{t("HelpCenter.BannerSection.Title")}</Heading>
            <Heading level="h4" light>
                {t("HelpCenter.BannerSection.Subtitle")}
            </Heading>
            <Image src={Illustration} alt="Illustration" className="illustration" />
        </div>
    );
};

export default BannerSection;
